import { isValidIban } from '../api/validation.service';
import { patterns } from '../settings';
import { startsWith } from './general';

export const isIban = (value: string) => patterns.IBAN_STRING.test(value);
export const isMaskedIban = (value: string) => patterns.IBAN_MASKED_STRING.test(value);
export const isGermanIban = (value: string) => startsWith('DE', value) && isIban(value);
export const isGermanMaskedIban = (value: string) => startsWith('DE', value) && isMaskedIban(value);
export const preventedIsValidIban = (value: string, checkoutId: number) => {
    if (!isGermanIban(value) && !isGermanMaskedIban(value)) {
        return Promise.resolve(false);
    }

    return isValidIban(checkoutId, value);
};
